module.exports = __webpack_public_path__ + "img/us-flag.a73a4b08.svg";